import { useEffect, useRef } from "react"

interface UseScrollIntoViewOptions {
  trigger: number | string | boolean
  enabled: boolean
}

interface UseScrollIntoViewReturn {
  ref: React.RefObject<HTMLElement>
}

export const useScrollIntoView = ({ trigger, enabled }: UseScrollIntoViewOptions): UseScrollIntoViewReturn => {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    if (enabled && ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      })
    }
  }, [trigger, enabled])

  return { ref }
}
